<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="selectionCode"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :footer-method="() => footerData"
      show-footer
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled && classification != 'C'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled && classification == 'C'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  type: 'edit',
                  code: row.evgPlanOrderWhCode,
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:whName="{ row }">
        <div>
          <span>{{ row.whName }} / {{ row.whRegionName }}</span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumn from './table-columns'
import tableDateColumns from './table-date-columns'
import EditLoading from '@/mixins/edit-loading'
import { format, add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    classification: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
          tools: 'toolbar_btn',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
    }
  },
  computed: {
    tableColumns() {
      return this.classification == 'C'
        ? tableColumn(this)
        : tableDateColumns(this)
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[2] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    async del(row) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const {
        evgPlanOrderCode,
        deliveryDate,
        beginShippingDate,
        endShippingDate,
        evgPlanOrderDetailCode,
      } = row
      let param = {}
      switch (this.classification) {
        case 'R':
          param = {
            evgPlanOrderCode,
            deliveryDate,
            beginShippingDate,
            endShippingDate,
            classification: this.classification,
          }
          break
        case 'M':
          param = {
            evgPlanOrderCode,
            evgPlanOrderDetailCode,
            classification: this.classification,
          }
          break
        default:
          this.loadingClose()
          return
      }

      const res = await this.$api
        .ecomEvgPackingSchemeWhDelApi({
          ...param,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
}
</style>
